export default {
	about_the: 'About the',
	document: 'Document',
	company_agency: 'Store registered in your profile:',
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files:
		'Explore our entire universe of courses, videos, articles and files.',
	project_name: 'Educa Tigre',
	welcome_to: 'Welcome to',
	challenge_of_the_day: "Challenge of the Beasts \\ Extra Challenge",
	profession: 'What is your area of activity today?',
}
